import PhoneInput from './PhoneInput'
import JsonInput from './JsonInput'
import NumberInput from './NumberInput'
import PasswordInput from './PasswordInput'
import TextInput from './TextInput'
import SelectInput from './SelectInput'
import TraditionalSelectInput from './TraditionalSelectInput'
import MultiTreeSelectAddListing from './MultiTreeSelectAddListing'
import TextAreaInput from './TextAreaInput'
import ProfileImageInput from './ProfileImageInput'
import CheckboxInput from './CheckboxInput'
import PriceInput from './PriceInput'
import SliderInput from './SliderInput'
import AdvancedSelectInput from './AdvancedSelectInput'
import MultiSelectInput from "./MultiSelectInput"
import MultiSelectInputOld from "./MultiSelectInputOld"
import ImageInput from "./ImageInput"
import AdvancedColorInput from "./AdvancedColorInput"
import SubformInput from "./SubformInput"
import SwitchInput from './SwitchInput'
import MapInput from './MapInput'
import SmartInput from './SmartInput'
import FilterEditor from './FilterEditor'
import IconManagerInput from './IconManagerInput'
import UsernameInput from './UsernameInput'
import DateInput from './DateInput'
import ColorInput from './ColorInput'
import GlobalUserInput from './GlobalUserInput'
import MapLeafletInput from './MapLeafletInput'
import IndoorLocationInput from './IndoorLocationInput'
import NewStatusIndicator from './NewStatusIndicator'
import StatusIndicator from './StatusIndicator'
import Calculator from './Calculator'
import CalendarRental from "./CalendarRental"
import FileInput from './FileInput'
import EditorInput from './EditorInput'
import AttributesLoader from './AttributesLoader'
import TableViewerInput from './TableViewerInput'
import MultiLevelInput from './MultiLevelInput'
import BooleanInput from './BooleanInput'


const inputComponents = {
    JsonInput,
    PhoneInput,
    NumberInput,
    PasswordInput,
    TextInput,
    SelectInput,
    BooleanInput,
    CalendarRental,
    TraditionalSelectInput,
    MultiTreeSelectAddListing,
    // ModifiedSelectInput,
    TextAreaInput,
    ProfileImageInput,
    CheckboxInput,
    AdvancedColorInput,
    PriceInput,
    SliderInput,
    AdvancedSelectInput,
    MultiSelectInput,
    MultiSelectInputOld,
    ImageInput,
    SubformInput,
    SwitchInput,
    MapInput,
    SmartInput,
    FilterEditor,
    IconManagerInput,
    UsernameInput,
    DateInput,
    ColorInput,
    GlobalUserInput,
    MapLeafletInput,
    IndoorLocationInput,
    NewStatusIndicator,
    StatusIndicator,
    Calculator,
    FileInput,
    EditorInput,
    AttributesLoader,
    TableViewerInput,
    MultiLevelInput


}

export default (inputComponents);
